import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { FilterCostsPerEmployeeGroup } from "../models/filters/filter-cost-per-employees-group";
import { CostsPerEmployeeGroup } from "../models/cost-per-employee-group";

@Injectable({
  providedIn: 'root'
})
export class CostsPerEmployeeGroupService { 

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/costsPerEmployeesGroup'; 

  findAllPageableCostsPerEmployeeGroup(filterCostsPerEmployeeGroup: FilterCostsPerEmployeeGroup, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterCostsPerEmployeeGroup);
  }

  findCostsPerEmployeeGroupById(id: number): Observable<CostsPerEmployeeGroup> {
    return this.http.get<CostsPerEmployeeGroup>(`${this.url}/${id}`);
  }

  createCostsPerEmployeeGroup(costsPerEmployeeGroup: CostsPerEmployeeGroup): Observable<CostsPerEmployeeGroup>{
    return this.http.post<CostsPerEmployeeGroup>(this.url, costsPerEmployeeGroup);
  }

  updateCostsPerEmployeeGroup(costsPerEmployeeGroup: CostsPerEmployeeGroup): Observable<CostsPerEmployeeGroup>{
    return this.http.put<CostsPerEmployeeGroup>(`${this.url}/${costsPerEmployeeGroup.id}`, costsPerEmployeeGroup);
  }

}